import { GameStatus } from "@/plugins/bingo/state/bingoGameStore";

const LABEL = {
  IDLE: "Ready",
  PRE_GAME_TRANSITION: "Starting",
  IN_PROGRESS: "Live",
  PAUSED: "Paused",
  REVIEWING: "Review",
  ANNOUNCING_WINNER: "Winner",
  GAME_SUMMARY: "Ended",
};

const COLOR = {
  IDLE: "var(--ic-active)",
  PRE_GAME_TRANSITION: "var(--ic-info)",
  IN_PROGRESS: "var(--ic-live)",
  PAUSED: "var(--ic-info)",
  REVIEWING: "var(--ic-info)",
  ANNOUNCING_WINNER: "var(--ic-primary)",
  GAME_SUMMARY: "var(--ic-text-muted)",
};

/**
 * StatusBadge — small In Progress / Paused indicator on the Projector.
 */
export default function StatusBadge({ status }) {
  const color = COLOR[status] || COLOR.IDLE;
  const label = LABEL[status] || LABEL.IDLE;
  const pulse = status === GameStatus.IN_PROGRESS;

  return (
    <div
      data-testid="projector-status-badge"
      className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 border ic-font-display"
      style={{
        borderColor: "var(--ic-border-subtle)",
        background: "rgba(0,0,0,0.4)",
      }}
    >
      <span
        className="w-2 h-2 rounded-full"
        style={{
          background: color,
          boxShadow: pulse ? `0 0 12px ${color}` : "none",
          animation: pulse ? "icPulse 1.6s ease-in-out infinite" : "none",
        }}
      />
      <span
        className="text-[10px] tracking-[0.35em] uppercase"
        style={{ color: "var(--ic-text-secondary)" }}
      >
        {label}
      </span>
      <style>{`
        @keyframes icPulse {
          0%,100% { opacity: 1; transform: scale(1); }
          50%     { opacity: 0.4; transform: scale(1.4); }
        }
      `}</style>
    </div>
  );
}
